import React from 'react';
import { Button } from './ui/button';
import { products, warrantyFor } from '../data/mock';
import { EMS_STATUS, DISPATCH_NOTE, DELIVERY_NOTE } from '../data/availability';
import { startCheckout, hasLink } from '../lib/checkout';
import ProductGallery from './ProductGallery';
import { toast } from 'sonner';

const Packages = () => {
  const handleCheckout = (product) => {
    try {
      const route = startCheckout(product, 'machine');
      if (route === 'enquiry') {
        toast.success('Opening WhatsApp so we can confirm your order and delivery.');
      }
    } catch (error) {
      console.error('Checkout error:', error);
      toast.error('Something went wrong. Please contact us and we will take the order directly.');
    }
  };

  return (
    <section id="packages" className="py-24 bg-gradient-to-b from-slate-950 to-black relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-testid="packages-title">
            The <span className="text-cyan-400 neon-text">Range</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Commercial-grade EMS body sculpting systems, direct to you
          </p>
          <p className="mt-3 text-sm text-cyan-400 font-semibold" data-testid="ems-availability">
            {EMS_STATUS} &middot; {DISPATCH_NOTE} &middot; {DELIVERY_NOTE}
          </p>
          <p className="mt-1 text-xs text-gray-500">Click any photo to enlarge it and see every angle</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 max-w-7xl mx-auto">
          {products.map((product) => (
            <div
              key={product.id}
              className="relative rounded-2xl overflow-hidden transition-all duration-500 group border border-cyan-500/30"
              data-testid={`product-card-${product.id}`}
            >
              <ProductGallery item={product} className="h-64" />

              <div className="bg-slate-900/90 p-6 space-y-4">
                <div className="text-center">
                  <h3 className="text-xl font-bold text-cyan-400">
                    {product.name}
                  </h3>
                  {product.finish && (
                    <p
                      className="mt-1.5 inline-block rounded-full border border-slate-600 px-2.5 py-0.5 text-[11px] text-gray-300"
                      data-testid={`finish-${product.id}`}
                    >
                      Finish: <span className="font-semibold text-white">{product.finish}</span>
                    </p>
                  )}
                  <p className="text-gray-400 text-sm mt-2">
                    {product.subtitle}
                  </p>
                  <p className="text-gray-500 text-xs mt-2">
                    {warrantyFor(product.priceAud)} year warranty included &middot; {DISPATCH_NOTE}
                  </p>
                </div>

                <Button
                  className="w-full bg-cyan-500 hover:bg-cyan-400 text-black font-bold rounded-full py-6"
                  onClick={() => handleCheckout(product)}
                  data-testid={`buy-btn-${product.id}`}
                >
                  <div className="flex flex-col items-center">
                    <span className="text-sm">
                      {hasLink('machine', product.id) ? 'Buy now' : 'Enquire to order'}
                    </span>
                    <span className="text-lg font-black">{product.price}</span>
                  </div>
                </Button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="/full-range"
            className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-300 font-semibold border border-cyan-500/40 hover:border-cyan-400 rounded-full px-6 py-3 transition-colors duration-300"
            data-testid="view-full-range-btn"
          >
            View the Full 24-Model Range
            <span aria-hidden="true">&rarr;</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Packages;
